import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import {
  Observable,
  debounceTime,
  distinctUntilChanged,
  filter,
  pairwise,
  startWith,
} from 'rxjs';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormSubscriptionService {
  public subscribeForm(formGroup: FormGroup | FormControl): Observable<[any, any]> {
    return formGroup.valueChanges.pipe(
      startWith(formGroup.value),
      debounceTime(700),
      distinctUntilChanged(),
      pairwise(),
      filter(([prev, current]) => JSON.stringify(prev) !== JSON.stringify(current)),
    );
  }

  public subscribeFormSimple(
    formGroup: FormGroup | FormControl | AbstractControl,
  ): Observable<any> {
    return formGroup.valueChanges.pipe(
      startWith(formGroup.value),
      debounceTime(600),
      distinctUntilChanged(),
    );
  }

  public unsubscribeAll(subscribeArray: Subscription[]): void {
    subscribeArray.forEach((sub) => sub.unsubscribe());
  }
}
